import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import DatoImage from '~components/dato-image';
import { useMeta } from '~store/meta';
import { Box, Container, Heading, Link, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { NextSeo } from 'next-seo';
var HomePage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = props.data;
    var meta = useMeta();
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                title: (ref = meta.site.seo) === null || ref === void 0 ? void 0 : ref.siteName
            }),
            /*#__PURE__*/ _jsx(Container, {
                maxW: "4xl",
                p: [
                    4,
                    8
                ],
                children: /*#__PURE__*/ _jsxs(Stack, {
                    align: "center",
                    spacing: 4,
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ _jsx(NextLink, {
                            href: "/about",
                            passHref: true,
                            children: /*#__PURE__*/ _jsx(Box, {
                                _hover: {
                                    bgColor: 'whiteAlpha.50'
                                },
                                as: "a",
                                borderRadius: "full",
                                maxW: "xs",
                                overflow: "hidden",
                                sx: {
                                    WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                                    MozBackfaceVisibility: 'hidden',
                                    WebkitBackfaceVisibility: 'hidden',
                                    MozTransform: 'translate3d(0, 0, 0)',
                                    WebkitTransform: 'translate3d(0, 0, 0)'
                                },
                                transform: "auto-gpu",
                                transitionDuration: "normal",
                                transitionProperty: "common",
                                transitionTimingFunction: "ease-out",
                                children: /*#__PURE__*/ _jsx(DatoImage, {
                                    data: (ref1 = data.site.favicon) === null || ref1 === void 0 ? void 0 : ref1.responsiveImage
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Heading, {
                            size: "2xl",
                            children: "Hey! I'm Fadhil Amadan."
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            color: "whiteAlpha.700",
                            fontSize: [
                                'lg',
                                'xl'
                            ],
                            maxW: "2xl",
                            children: (ref2 = meta.site.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fallback) === null || ref3 === void 0 ? void 0 : ref3.description
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            color: "whiteAlpha.400",
                            children: "\xb7 \xb7 \xb7"
                        }),
                        /*#__PURE__*/ _jsxs(Text, {
                            pb: 8,
                            children: [
                                "Reach me via email at",
                                ' ',
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "mailto:".concat((ref4 = meta.about) === null || ref4 === void 0 ? void 0 : ref4.email),
                                    variant: "link",
                                    children: (ref5 = meta.about) === null || ref5 === void 0 ? void 0 : ref5.email
                                }),
                                ", or Twitter at",
                                ' ',
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "https://twitter.com/".concat((ref6 = meta.site.seo) === null || ref6 === void 0 ? void 0 : ref6.twitterAccount),
                                    isExternal: true,
                                    variant: "link",
                                    children: (ref7 = meta.site.seo) === null || ref7 === void 0 ? void 0 : ref7.twitterAccount
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};
export var __N_SSG = true;
export default HomePage;
